// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {
    sjlists
} from "@/api/index";

Vue.use(Vuex)

function loadFromLocalStorage() {
    try {
        const serializedState = localStorage.getItem('exam')
        if (serializedState === null) {
            return undefined
        }
        return JSON.parse(serializedState)
    } catch (err) {
        return undefined
    }
}

function saveToLocalStorage(state) {
    try {
        const serializedState = JSON.stringify(state.currentExam)
        localStorage.setItem('exam', serializedState)
    } catch (err) {
    }
}

const persistedState = loadFromLocalStorage()

export default new Vuex.Store({
    state: {
        exams: [], // 存储从API获取的考试列表
        currentExam: persistedState || null, // 当前考试信息 { id, name, durationSeconds, startTime }
        countdownInterval: null,
    },
    mutations: {
        SET_EXAMS(state, exams) {
            state.exams = exams
        },
        SET_CURRENT_EXAM(state, exam) {
            state.currentExam = exam
            saveToLocalStorage(state) // 每次更新当前考试信息时保存到localStorage
        },
        START_COUNTDOWN(state) {
            if (state.countdownInterval) return

            state.countdownInterval = setInterval(() => {
                if (!state.currentExam) return

                const now = Math.floor(Date.now() / 1000)
                const remaining = state.currentExam.durationSeconds - (now - state.currentExam.startTime)

                if (remaining <= 0) {
                    clearInterval(state.countdownInterval)
                    state.countdownInterval = null

                    // 自动交卷逻辑
                    state.currentExam = null
                    saveToLocalStorage(state) // 清除localStorage中的考试信息
                    // this.dispatch('submitExam') // 调用自动交卷API
                } else {
                    state.currentExam.remaining = remaining
                    saveToLocalStorage(state) // 更新localStorage中的剩余时间
                }
            }, 1000)
        },
        STOP_COUNTDOWN(state) {
            if (state.countdownInterval) {
                clearInterval(state.countdownInterval)
                state.countdownInterval = null
                state.currentExam = null
            }
        },
    },
    actions: {
        fetchExams({commit}) {
            console.log('9999')
            sjlists({}).then(res => {
                if (res.code == 1) {
                    let list = res.data
                    for (let i in list) {
                        list[i].new_id = Number(i) + 1
                    }
                    commit('SET_EXAMS', res.data)
                }
            })
        },
        startExam({commit, state}, examId) {
            const exam = state.exams.find(e => e.new_id === examId)
            const now = Math.floor(Date.now() / 1000)
            const examWithTime = {
                ...exam,
                startTime: now,
                durationSeconds: exam.detail[0].time * 60, // 总时间（秒）
                remaining: exam.detail[0].time * 60,
            }

            commit('SET_CURRENT_EXAM', examWithTime)
            if (!state.countdownInterval) {
                commit('START_COUNTDOWN')
            }
        },
        continueExam({commit, state}, examId) {
            const exam = state.currentExam
            commit('SET_CURRENT_EXAM', exam)
            if (!state.countdownInterval) {
                commit('START_COUNTDOWN')
            }
        },
        stopCountdown({commit}) {
            commit('STOP_COUNTDOWN')
        },
        submitExam({state}) {
            axios.post('/api/submitExam', {
                examId: state.currentExam.id,
                answers: {} // 假设这里是你需要提交的答案数据
            }).then(response => {
                this.$message.success('试卷已成功提交！')
            }).catch(error => {
                console.error("There was an error submitting the exam!", error);
            })
        }
    },
    getters: {
        examsList(state) {
            return state.exams.map(exam => {
                if (state.currentExam?.new_id === exam.new_id && state.currentExam.remaining > 0) {
                    return {
                        ...exam,
                        status: '进行中',
                        buttonLabel: '继续考试',
                    }
                } else {
                    return {
                        ...exam,
                        status: '未开始',
                        buttonLabel: '开始考试',
                    }
                }
            })
        },
        formattedRemaining(state) {
            const remaining = state.currentExam?.remaining || 0
            const h = Math.floor(remaining / 3600)
            const m = Math.floor((remaining % 3600) / 60)
            const s = remaining % 60
            return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
        },
    },
})
